import * as Yup from "yup";
import { forceInt } from "Utils";

export const AttachmentValidationSchema = Yup.object().shape({});

export const AttachmentObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    user_id: null,
    state: null,
    created_at: null,
    modified_at: null,
    base_name: null,
    extension: null,
    parent_id: null,
    content_id: null,
    height: null,
    width: null,
    size_name: null,
    type: null,
    preview_extension: null,
    container_id: null,
    metadata: null,
    public_url: null,
    original_url: null,
    imgix_url: null,
    encoding_state: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let attachment = Object.assign({}, AttachmentObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        state: requestData.state,
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
        base_name: requestData.base_name,
        extension: requestData.extension,
        parent_id: forceInt(requestData.parent_id),
        content_id: forceInt(requestData.content_id),
        height: requestData.height,
        width: requestData.width,
        size_name: requestData.size_name,
        type: requestData.type,
        preview_extension: requestData.preview_extension,
        container_id: forceInt(requestData.container_id),
        metadata: requestData.metadata,
        public_url: requestData.public_url,
        original_url: requestData.original_url,
        imgix_url: requestData.imgix_url,
        encoding_state: requestData.encoding_state,
    });

    return attachment;
}
